// The DM's download of the table's whole history (2026-09-26): every change,
// when, who and what, a move's route point by point. The server refuses it to
// anyone but the DM; the menu offers it to the DM alone. Saved as a file the
// person keeps — the QA agent checks its reports against it.
import { authFetch } from './session';

/** Fetch the history and hand it to the browser as a download. False when it could not be had. */
export async function saveHistory(campaignId: string, tableName: string, fetchImpl: typeof fetch = fetch, doc: Document = document): Promise<boolean> {
  try {
    const res = await authFetch(`/api/tables/${campaignId}/history.json`, {}, fetchImpl);
    if (!res.ok) return false;
    const text = await res.text();
    const url = URL.createObjectURL(new Blob([text], { type: 'application/json;charset=utf-8' }));
    const a = doc.createElement('a');
    a.href = url;
    a.download = `${tableName.replace(/[^\w.-]+/g, '_')}-history.json`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch {
    return false;
  }
}
